import { AMBER_STATUS_METRIC_VALUE_TEXT } from "@/theme";
import { WellnessScoreStatus } from "./types";

export type WellnessFlagIconLoaderProps = {
  color: "accent1" | "error" | "secondary";
  sx?: { color: string };
};

const NEEDS_ATTENTION_FLAG_PROPS: WellnessFlagIconLoaderProps = {
  color: "secondary",
  sx: { color: AMBER_STATUS_METRIC_VALUE_TEXT },
};

export function getWellnessFlagIconProps(
  status: WellnessScoreStatus
): WellnessFlagIconLoaderProps {
  switch (status) {
    case WellnessScoreStatus.Healthy:
      return { color: "accent1" };
    case WellnessScoreStatus.NeedsSupport:
      return { color: "error" };
    case WellnessScoreStatus.NeedsAttention:
    default:
      return NEEDS_ATTENTION_FLAG_PROPS;
  }
}
